import {Component, Input} from '@angular/core';
import {Token} from "../../../modules/auth/models/token";
import {AuthService} from "../../../modules/auth/services/auth-service";
import Swal from "sweetalert2";
import {ToastrService} from "ngx-toastr";
import {ThemeService} from "../../services/theme.service";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.css',
    standalone: false
})
export class SidebarComponent {
  @Input() ativo = '';
  token: Token | undefined;
  showModalFeedback = false;
  tipoSaas = 1;
  isDarkTheme = false;
  showMensagensSubmenu = false;
  showGestaoSubmenu = false;
  isSdr = false;

  constructor(private tokenService: AuthService,
              private toastr: ToastrService,
              private themeService: ThemeService) {
    this.token = this.tokenService.AccessToken;
    this.isSdr = this.token?.seguranca === 'SDR';

    this.themeService.isDarkTheme$().subscribe(isDark => {
      this.isDarkTheme = isDark;
    });
  }

  logoff(){
    Swal.fire({
      title: 'Deseja realmente sair?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#2E5266',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.value){
        this.tokenService.logoff();
        this.toastr.warning("Volte sempre!");
      }
    });
  }

  abrirModal(){
    this.showModalFeedback = true;
  }

  fecharModal(){
    this.showModalFeedback = false;
  }

  toggleMensagensSubmenu() {
    this.showMensagensSubmenu = !this.showMensagensSubmenu;
  }

  toggleGestaoSubmenu() {
    this.showGestaoSubmenu = !this.showGestaoSubmenu;
  }
}
